import React from 'react';
import { Navigate } from 'react-router';
import { useUserRoles } from 'hooks/useUserRoles';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

interface Props {
  children: React.ReactNode;
}

/**
 * Gates the private Partner API page to accounts with the partner-api flag.
 * Mirrors BlogRoute: require an authenticated session first, then the role.
 * The role check is UI-only; the backend enforces access on every request.
 */
const PartnerRoute = ({ children }: Props) => {
  // In cookie mode, check for user data instead of token
  const token = useSelector((state: RootState) => state.auth.token);
  const user = useSelector((state: RootState) => state.auth.user);
  const isAuthenticated = token || user;
  const { isPartner, rolesResolved } = useUserRoles();

  if (!isAuthenticated) {
    return <Navigate to="/welcome" replace />;
  }

  // Wait for /users/me to settle before deciding. Without this, a flagged partner
  // who refreshes or deep-links here is briefly bounced to /home while the roles
  // query is still in flight (user undefined => isPartner false).
  if (!rolesResolved) {
    return null;
  }

  if (!isPartner) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};

export default PartnerRoute;
